import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { CREATE_ROOM, CreateRoomActionType, SET_ROOM_CREATED } from '../redux/janusReducer'

function* CreateRoomFlow(action: CreateRoomActionType): Generator<any, void, any> {
  try {
    yield call(apiCall, {
      endpoint: `/tutors/lessons/${action.payload.id}/create_janus_room`,
      method: 'POST',
      params: {}
    })
    yield put(SET_ROOM_CREATED(true))
  } catch (error) {
    console.log(error)
  }
}

export default function* CreateRoomSaga(): Generator<any, void, any> {
  yield takeLatest([CREATE_ROOM], CreateRoomFlow)
}
